<template>
    <!--Waiting List Modal-->
    <div class="modal fade waiting-list-modal" :id="id" tabindex="-1" :aria-labelledby="id + 'Label'"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">

                <!-- Header -->
                <div class="modal-header">
                    <h5 class="modal-title" :id="id + 'Label'">
                        {{ title }}
                    </h5>

                    <!-- Bootstrap 5 close button -->
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <!-- Body -->
                <div class="modal-body">
                    <p v-if="p1" v-html="p1"></p>
                    <p v-if="p2" v-html="p2"></p>
                    <p v-if="p3" v-html="p3"></p>
                    <p v-if="p4" v-html="p4"></p>
                </div>

                <!-- Footer -->
                <div class="modal-footer">
                    <div class="enroll-btn">

                        <!-- Primary action -->
                        <button @click="handleActionModal" type="button" class="primary-btn extra-small mobile"
                            data-bs-dismiss="modal">
                            {{ buttonText }}
                        </button>

                        <!-- Secondary button -->
                        <button v-if="removeClient || cancelSubscription || cancelWaitlistClient" type="button"
                            class="secondary-btn small mobile" data-bs-dismiss="modal">
                            {{ buttonText2 }}
                        </button>

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        id: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        p1: {
            type: String,
        },
        p2: {
            type: String,
        },
        p3: {
            type: String,
        },
        p4: {
            type: String,
        },
        buttonText: {
            type: String,
        },
        buttonText2: {
            type: String,
        },
        removeClient: {
            type: Boolean,
        },
        cancelSubscription: {
            type: Boolean,
        },
        cancelWaitlistClient: {
            type: Boolean,
        }
    },
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {
        handleActionModal() {
            if(this.cancelSubscription) {
                this.$emit("cancel-subscription")
            }

            if(this.removeClient) {
                this.$emit("remove-client")
            }

            if (this.cancelWaitlistClient) {
                this.$emit("cancel-waitlist-client")
            }
        },
    },
};
</script>
